import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  IconProp,
  SizeProp,
  RotateProp,
} from '@fortawesome/fontawesome-svg-core'

export type IconProps = {
  icon: IconProp
  size?: SizeProp
  className?: string
  color?: string
  spin?: boolean
  pulse?: boolean
  rotation?: RotateProp
  flip?: 'horizontal' | 'vertical' | 'both'
  onClick?: () => void
  style?: React.CSSProperties
  title?: string
}

const Icon: React.FC<IconProps> = ({ icon, size = '1x', ...props }) => (
  <FontAwesomeIcon icon={icon} size={size} {...props} />
)

export { Icon }
export default Icon
